// extracted by mini-css-extract-plugin
export default {"root":"HeaderContent-root__KIY1"};